import React, { Component } from 'react';
import { connect } from 'react-redux';
import './PageTemplate.scss';

//components
import { push } from 'connected-react-router';
import Assistant from '../Assistant/Assistant';
import TitleBar from '../TitleBar/TitleBar';
import { loadContentForPage,setTextToSpeak } from '../../redux/actions/text.action';
import Div100vh from 'react-div-100vh'

/**
 * Template for pages with an assistant
 */
class PageTemplate extends Component<{ navigateTo: any, assistantLine1: string, assistantLine2?: string, body: any, customBack?: any, setCurrentpage: any, page?: string, speak: any, text?: any}, {}> {

    componentDidMount() {
        if(this.props.page) {
            this.props.setCurrentpage(this.props.page);
        } 
    }

    /**
     * Main render method of component
     */
    render() {
        return (
            <div className="pagetemplate">
                <TitleBar back={this.props.customBack} page={this.props.page} />
                <div className="container">
                    <Assistant textLine1={this.props.assistantLine1? this.props.assistantLine1 : ""} textLine2={this.props.assistantLine2 ? this.props.assistantLine2 : ""} text={this.props.text}/>
                    {this.props.body}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {

    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        navigateTo(path: string) {
            dispatch(push(path));
        },
        setCurrentpage(page: string) {
            dispatch(loadContentForPage(page))
        },
        speak(text: string) {
            dispatch(setTextToSpeak(text))
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PageTemplate);